

import Rating from "../ob1/Rating.vue";
import {InfoLine, InfoLineStatus} from "./models/InfoLine";

export default {
    name: "SoldByCard",
    components: {Rating},
    props: {
        isLarge: {
            type: Boolean,
            default: false
        },
        soldByOrange: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        infoLines: {
            type: Array as () => InfoLine[],
            default: (): InfoLine[] => []
        },
        rating: {
            type: Number,
            default: null
        }
    },
    computed: {
        classes(): Record<string, boolean> {
            return {
                "sold-by-card-large" : this.isLarge,
                "sold-by-card-padded" : this.infoLines.length > 0 || this.rating !== null,
                "sold-by-orange" : this.soldByOrange,
                "sold-by-other" : !this.soldByOrange,
            };
        }
    },
    mounted() {
    },
    methods: {
        alertClass(status: InfoLineStatus): string {
            return status === InfoLineStatus.WARNING ? 'alert-warning' : 'alert-success'
        }
    }
}

